import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Rebound Net caught by offense fragment for Indoor Football.
 * When the ball hits the rebound net and is caught by the offensive team.
 */
export default class ReboundNetCaughtOffense extends Fragment {
    constructor(caughtBy, caughtAt) {
        super();
        this.code = "RBNCO";
        this.caughtBy = caughtBy;
        this.caughtAt = caughtAt;

        this.requiredData = [
            {
                name: "caughtBy",
                type: FragmentDataType.Player,
                displayName: "Caught By",
                title: (team) => `Caught By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "caughtAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    getFieldPosition() {
        return this.caughtAt;
    }

    getPlayers() {
        return [this.caughtBy];
    }

    getFragmentTeamId() {
        return this.caughtBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        const message = `caught by ${stringifier.firstInitial(this.caughtBy)}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.caughtAt || this.caughtAt === 0) {
            summaryContext.fieldPosition = this.caughtAt;
        }
        summaryContext.playerInPossession = this.caughtBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            caughtBy: playerReducer(this.caughtBy)
        };
    }
}
